module.exports = __webpack_public_path__ + "russierenouvelables/img/energy-use.5012c471.webp";